import React from "react";
import ReactDOM from "react-dom";
import axios from 'axios';

import withRouter from '../libs/withRouter.jsx';
import withAuth from "../libs/withAuth.jsx";
import copyTextToClipboard from "../libs/copyTextToClipboard.jsx";
import Loader from "../libs/loader.jsx";
import Monday from "../auth/useMonday.jsx";


import { Button, Heading, TextField, Tooltip, Icon, Link } from "@vibe/core";
import { Duplicate, Retry, Alert, ExternalPage, Show } from "@vibe/icons";

import mondaySdk from "monday-sdk-js";
const monday = mondaySdk();
monday.setApiVersion(config.monday_api.version);

class Tracket extends React.Component
{
    constructor(props)
    {
        super(props);
        //console.log("AccessToken props",this.props);
        this.params = this.props.router.params;
        
        this.state = {
            'api_client_id': '',
            'api_client_secret': '',
            'tracket_valid': (this.props.auth.tracketTokenValid===false)?false:true,
            'save_loading': false,
            'revoke_loading': false,
            'loading': false,
            'textfield_client_secret_type': TextField.types.PASSWORD,
        };
        
        this.loader = React.createRef();
    }
    
    copy(e)
    {
        //console.log('copy',e);
        copyTextToClipboard(this.state.token, 'Token copied to clipboard');
    }
    
    saveTracket(e)
    {
        var this_component = this;
        
        this_component.setState({'save_loading':true});
        
        var data = new FormData();
        data.append('api_client_id', this_component.state.api_client_id);
        data.append('api_client_secret', this_component.state.api_client_secret);
        
        axios.post('/api/v1/extension_tracket/save_tracket', data)
            .then(response => {

                if(response.data.error==0)
                {
                    this_component.setState({'save_loading':false});
                    this_component.setState({'revoke_loading':false});
                    
                    if(response.data.valid == true)
                    {
                        this_component.setState({'tracket_valid':true});
                        this_component.props.auth.setTracketTokenValid(true);
                    
                        monday.execute("notice", { 
                            message: 'Token accepted. '+config.texts.name+' will now have access to your Tracket data',
                            type: "success", // or "error" (red), or "info" (blue)
                            timeout: 10000,
                        });

                        //document.location.href = document.location.href;

                        //this_component.getToken();
                    }
                    else
                    {
                        
                        monday.execute("notice", { 
                            message: 'Validation error. Please enter a valid Tracket Token',
                            type: "error", // or "error" (red), or "info" (blue)
                            timeout: 10000,
                        });
                        
                    }
                    
                    //console.log("auth",{...this_component.props.auth});
                }
                
                this_component.loader.current.hideLoader();
            })
            .catch(error => {
                console.log('Tracket Token save error', error, error.response);

                if('error_message' in error.response.data)
                {
                    monday.execute("notice", { 
                        message: error.response.data.error_message,
                        type: "error", // or "error" (red), or "info" (blue)
                        timeout: 30000,
                    });
                }
                
                if('errors' in error.response.data)
                {
                    monday.execute("notice", { 
                        message: 'Validation error. Please enter a valid Tracket Token',
                        type: "error", // or "error" (red), or "info" (blue)
                        timeout: 10000,
                    });
                    //this_component.setState({'tracket_valid':false});
                }
                
                
                
                this_component.setState({'save_loading':false});
                this_component.setState({'revoke_loading':false});
                //this_component.getToken();
            });
    }
    
    revokeTracket(e)
    {
        var this_component = this;
        
        this_component.setState({'revoke_loading':true});
        
        var data = new FormData();
        
        axios.post('/api/v1/extension_tracket/revoke', data)
            .then(response => {

                if(response.data.error==0)
                {
                    this_component.setState({'save_loading':false});
                    this_component.setState({'revoke_loading':false});
                        
                    this_component.setState({'api_client_id':''});
                    this_component.setState({'api_client_secret':''});
                    
                    this_component.setState({'tracket_valid':null});
                    this_component.props.auth.setTracketTokenValid(null);

                    monday.execute("notice", { 
                        message: 'Tracket Token successfully revoked',
                        type: "success", // or "error" (red), or "info" (blue)
                        timeout: 10000,
                    });
                }
                
                this_component.loader.current.hideLoader();
            })
            .catch(error => {
                
                console.log('Tracket Token revoke error', error, error.response);

                if('error_message' in error.response.data)
                {
                    monday.execute("notice", { 
                        message: error.response.data.error_message,
                        type: "error", // or "error" (red), or "info" (blue)
                        timeout: 30000,
                    });
                }
                
                this_component.setState({'save_loading':false});
                this_component.setState({'revoke_loading':false});
            });
    }
    
    
    onChangeApiClientId(value)
    {
        var this_component = this;
        this_component.setState({'api_client_id': value});
    }


    onChangeApiClientSecret(value)
    {
        var this_component = this;
        this_component.setState({'api_client_secret': value});
    }
    
    onShowApiClientSecret(value)
    {
        var this_component = this;

        if(this_component.state.textfield_client_secret_type == TextField.types.PASSWORD)
        {
            this_component.setState({'textfield_client_secret_type': TextField.types.TEXT});
        }
        else
        {
            this_component.setState({'textfield_client_secret_type': TextField.types.PASSWORD});
        }
    }

    
    getTracket()
    {
        var this_component = this;
        
        this_component.loader.current.showLoader();
        
        axios.get('/api/v1/extension_tracket/get', { 'params': {} } )
            .then(response => {
                //console.log(response);
                if(response.data.error==0)
                {
                    this_component.setState({'api_client_id': response.data.api_client_id});
                    this_component.setState({'api_client_secret': response.data.api_client_secret});
                }
                this_component.loader.current.hideLoader();
            }).catch(error => {
                console.log('Tracket getTracket error', error, error.response);

                if('error_message' in error.response.data)
                {
                    monday.execute("notice", { 
                        message: error.response.data.error_message,
                        type: "error", // or "error" (red), or "info" (blue)
                        timeout: 30000,
                    });
                }
                
                this_component.loader.current.hideLoader();
            });
    }


    componentDidMount()
    {
        var this_component = this;
        this.getTracket();
    }

    
    render()
    {
        var this_component = this;
        
        return (
            <Loader ref={this_component.loader}>
                
                <div className="form-group form-row mb-2">
                    <div className="col-12 col-sm-12 col-md-6">
                        <Heading type="h2" color="primary" className="titleFont">Tracket Token</Heading>
                    </div>
                </div>

                <div className="form-group form-row mb-2">
                    <div className="col-12 col-sm-12 col-md-6 mb-2">
                        {
                            (this_component.state.tracket_valid===false)?
                            <div className="mb-2"><Icon icon={Alert} style={{'color': "var(--color-error)", 'verticalAlign': 'sub'}} iconSize="19" />Validation error. Please enter a valid Tracket credentials</div>
                            :
                            null
                        }
                        <TextField placeholder="Tracket Client Id *" className="form-control" type={TextField.types.TEXT} size={TextField.sizes.MEDIUM} controlled={true} value={this_component.state.api_client_id} required={true} id="api_client_id" readonly={false} onChange={(value) => this_component.onChangeApiClientId(value)} />
                    
                    </div>
                </div>
                
                <div className="form-group form-row mb-2">
                    <div className="col-12 col-sm-12 col-md-6 mb-2">
                        
                        <TextField placeholder="Tracket Client Secret *" className="form-control" type={this_component.state.textfield_client_secret_type} size={TextField.sizes.MEDIUM} controlled={true} value={this_component.state.api_client_secret} iconName={Show} onIconClick={(value) => this_component.onShowApiClientSecret(value)} required={true} id="api_client_secret" readonly={false} onChange={(value) => this_component.onChangeApiClientSecret(value)} />
                    
                    </div>
                </div>
                
                <div className="form-group form-row mb-2">
                    <div className="col-12 col-sm-12 col-md-6 mb-2" style={{ 'display': 'flex' }}>
                         <Button onClick={(e) => this_component.saveTracket(e)} type={Button.inputTags.BUTTON} kind={Button.kinds.PRIMARY} size={Button.sizes.MEDIUM} marginLeft={false} loading={this_component.state.save_loading} style={{ 'marginTop': 'auto' }}>Validate & Save</Button>
                        
                        <Tooltip content={"Revoke access"} position={Tooltip.positions.BOTTOM} referenceWrapperClassName="mt-auto">
                            <Button onClick={(e) => this_component.revokeTracket(e)} color={Button.colors.NEGATIVE} type={Button.inputTags.BUTTON} kind={Button.kinds.PRIMARY} size={Button.sizes.MEDIUM} marginLeft={true} loading={this_component.state.revoke_loading} style={{ }}>Revoke</Button>
                        </Tooltip> 
                    </div>
                </div>
                
                <div className="form-group form-row mb-2">
                    <div className="col-12 col-sm-12 col-md-6 mb-2" style={{ 'display': 'flex' }}>
                        <Link className="pt-2" text="How to get Client ID and Client Secret" href={config.texts.url_tracket_how_to} target="_blank" iconPosition="end" icon={ExternalPage} />
                    </div>
                </div>

            </Loader>
        );
    }
    
}

Tracket.defaultProps = {
};

export default withRouter(withAuth(Tracket));
